<template>
  <div
    class="active-info"
    :class="{
      'h5-active-info': isH5,
    }"
  >
    <div class="active-info-top">
      <!-- 团长昵称 -->
      <div class="result">{{ leaderNickname }}</div>
      <!-- 倒计时 -->
      <div v-if="!isEnd" class="count-down">
        拼团剩余 <span>{{ countdown.hours }}</span> :
        <span>{{ countdown.minutes }}</span> :
        <span>{{ countdown.seconds }}</span>
      </div>
      <div v-if="isEnd" class="count-down">已结束</div>
    </div>
    <div class="active-info-list">
      <div class="active-info-message">{{ userListMessage }}</div>
      <div
        v-if="showArrow"
        @click="handleClickArrow('left')"
        class="arrow left-arrow"
      ></div>
      <div
        v-if="showArrow"
        @click="handleClickArrow('right')"
        class="arrow right-arrow"
      ></div>
      <div class="active-info-user-list" ref="userList">
        <div class="user-list">
          <div
            class="user-item"
            :class="{ 'user-item-leader': item.is_leader === 1 }"
            v-for="(item, index) in activeInfo.memberList || {}"
            :key="index"
          >
            <div class="avater"><img :src="item.avatar" alt="" /></div>
            <div class="name">{{ item.nickname.slice(0, 1) }}***</div>
            <div class="leader-tag" v-if="index == 0">团长</div>
            <div class="refund-tag" v-if="[1, 4].includes(item.state)">
              {{ item.state === 4 ? "已退款" : "待支付" }}
            </div>
          </div>
          <div
            class="join-box"
            v-for="(item, index) in new Array(activeInfo.diffNum).fill('a')"
            :key="index + item"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isH5 } from "@saas/components/src";
export default {
  props: {
    courseInfo: {
      type: Object,
      default: () => {},
    },
    activeInfo: {
      type: Object,
      default: () => {},
    },
    canExceed: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isH5: isH5(),
      countdown: {},
      timerId: null,
      isEnd: false, //团购倒计时结束
    };
  },
  beforeDestroy() {
    this.stopCountdown();
  },
  methods: {
    stopCountdown() {
      clearInterval(this.timerId);
      this.timerId = null;
    },
    startCountdown(targetDateString) {
      this.stopCountdown(); // 防止重复启动
      this.timerId = setInterval(() => {
        this.countdown = this.calculateCountdown(targetDateString);
      }, 1000);
    },
    calculateCountdown(dateString) {
      const targetDate = new Date(dateString);
      const now = new Date();
      const difference = targetDate.getTime() - now.getTime();

      if (difference <= 0) {
        this.stopCountdown();
        this.isEnd = true;
        // 刷新页面
        window.location.reload();
        return {};
      }

      const totalHours = Math.floor(difference / (1000 * 60 * 60));
      const hours = totalHours % 24;
      const minutes = Math.floor((difference / 1000 / 60) % 60);
      const seconds = Math.floor((difference / 1000) % 60);

      // 如果总小时数超过24小时，直接展示总小时数
      return totalHours >= 24
        ? {
            hours: totalHours < 10 ? "0" + totalHours : totalHours,
            minutes: minutes < 10 ? "0" + minutes : minutes,
            seconds: seconds < 10 ? "0" + seconds : seconds,
          }
        : {
            hours: hours < 10 ? "0" + hours : hours,
            minutes: minutes < 10 ? "0" + minutes : minutes,
            seconds: seconds < 10 ? "0" + seconds : seconds,
          };
    },
    handleClickArrow(type) {
      if (type === "left") {
        this.$nextTick(() => {
          this.$refs.userList.scrollLeft -= 400;
        });
      } else {
        this.$refs.userList.scrollLeft += 400;
      }
    },
  },
  computed: {
    // 待成团 1
    NO_GROUP: () => 1,
    // 拼团成功 2
    GROUP_SUCCESS: () => 2,
    // 拼团失败 3
    GROUP_FAIL: () => 3,
    // 团长昵称
    leaderNickname() {
      if (this.activeInfo?.member_list?.length) {
        let str = "***邀请你拼团";
        let leader = this.activeInfo.member_list.filter((item) => {
          return item.is_leader === 1;
        });
        if (leader?.length) {
          str = leader[0].nickname.slice(0, 1) + str;
        }
        return str;
      } else {
        return "";
      }
    },
    // 拼团列表提示信息
    userListMessage() {
      if (this.activeInfo.state === 1) {
        // 待成团
        return `还差 ${this.activeInfo.diffNum} 人，人满成团后可开通课程`;
      } else if (this.activeInfo.state === 2 && this.canExceed) {
        return "已成团，可继续加入";
      } else {
        return "";
      }
    },
    showArrow() {
      let length = this.activeInfo?.memberList?.length || 0;
      return !isH5 && length + this.activeInfo.diffNum > 8;
    },
  },
  watch: {
    "activeInfo.end_at": {
      handler(newVal) {
        if (newVal) {
          this.startCountdown(newVal * 1000);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.active-info {
  width: 800px;
  height: 318px;
  margin-top: 24px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center center;
  background-image: url("../../../assets/images/group-activity/success_bg_h5.png");
  .active-info-top {
    height: 102px;
    width: 100%;
    padding: 0 43px 0 48px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .result {
      height: 42px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 600;
      font-size: 30px;
      color: $saas-text-color;
      line-height: 42px;
      text-align: left;
      font-style: normal;
      padding-top: 28px;
    }
    .count-down {
      padding-top: 30px;
      font-size: 22px;
      color: $saas-text-color;
      span {
        display: inline-block;
        width: 32px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        border-radius: 8px;
        background: $saas-text-color;
        color: #fff;
      }
    }
  }
  .active-info-list {
    width: 752px;
    height: 192px;
    background: #ffffff;
    border-radius: 24px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
    .active-info-message {
      font-size: 22px;
      color: $saas-text-color;
      line-height: 24px;
      padding-top: 20px;
      padding-left: 24px;
    }
    .arrow {
      position: absolute;
      top: 44px;
      width: 24px;
      height: 132px;
      background: linear-gradient(
        90deg,
        #ffffff 0%,
        rgba(255, 255, 255, 0.8) 100%
      );
      cursor: pointer;
      z-index: 10000;
    }
    .left-arrow {
      left: 0;
      background-image: url("../../../assets/images/group-activity/arrow.png");
      background-repeat: no-repeat;
      background-size: 16px 16px;
      background-position: center center;
    }
    .right-arrow {
      right: 0;
      background-image: url("../../../assets/images/group-activity/arrow.png");
      background-repeat: no-repeat;
      background-size: 16px 16px;
      background-position: center center;
      transform: rotate(180deg);
    }
    .active-info-user-list {
      width: 100%;
      margin-top: 24px;
      padding-right: 24px;
      scrollbar-width: 0;
      /* 标准语法，Firefox 支持 */
      -ms-overflow-style: none;
      /* IE 和 Edge */
      &::-webkit-scrollbar {
        display: none;
        /* WebKit 内核浏览器 */
      }
      scroll-snap-type: x mandatory;
      overflow-x: scroll;
      overflow-y: hidden;
      scroll-behavior: smooth;
      .user-list {
        display: inline-flex;
        flex-direction: row;
        flex-wrap: nowrap;
        min-width: 0;
      }
      .user-item {
        float: left;
        width: 80px;
        margin-left: 24px;
        position: relative;
        .avater {
          width: 80px;
          height: 80px;
          border-radius: 50%;
          overflow: hidden;
          border: 1px solid #ffe3ef;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .name {
          margin-top: 6px;
          width: 100%;
          text-align: center;
          font-size: 16px;
          color: #747573;
          line-height: 22px;
        }
        .leader-tag {
          position: absolute;
          top: 56px;
          left: 50%;
          transform: translateX(-50%);
          width: 54px;
          height: 28px;
          background-image: url("../../../assets/images/group-activity/tag_bg.png");
          background-position: center center;
          background-repeat: no-repeat;
          background-size: 100% 100%;
          font-size: 18px;
          color: #ffffff;
          text-align: center;
          z-index: 9;
        }
        .refund-tag {
          position: absolute;
          left: 0;
          top: 0;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          text-align: center;
          line-height: 80px;
          font-size: 16px;
          background: rgba(0, 0, 0, 0.4);
          border: 1px solid #ffe3ef;
          color: #fff;
        }
      }
      .user-item-leader {
        .avater {
          border-color: #ff3c74;
        }
      }
      .join-box {
        float: left;
        width: 80px;
        height: 80px;
        background-image: url("../../../assets/images/group-activity/add_btn.png");
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-left: 24px;
      }
    }
  }
}
.h5-active-info {
  margin: 0 auto;
  width: 9.36rem;
  height: 3.8933rem;
  margin-top: 0.32rem;
  .active-info-top {
    height: 1.1867rem;
    width: 100%;
    padding: 0 0.5467rem 0 0.5333rem;
    .result {
      height: 0.6rem;
      font-size: 0.4267rem;
      line-height: 0.6rem;
      padding-top: 0.32rem;
    }
    .count-down {
      padding-top: 0.36rem;
      font-size: 0.2933rem;
      span {
        width: 0.3733rem;
        height: 0.3733rem;
        line-height: 0.3733rem;
        border-radius: 0.0933rem;
      }
    }
  }
  .active-info-list {
    width: 8.8267rem;
    height: 2.44rem;
    border-radius: 0.28rem;
    .active-info-message {
      font-size: 0.32rem;
      line-height: 0.28rem;
      padding-top: 0.2267rem;
      padding-left: 0.2667rem;
    }
    .active-info-user-list {
      overflow: auto;
      margin-top: 0.24rem;
      padding-right: 0.32rem;
      .user-item {
        width: 1.0667rem;
        margin-left: 0.2933rem;
        .avater {
          width: 1.0667rem;
          height: 1.0667rem;
        }
        .name {
          margin-top: 0.08rem;
          font-size: 0.2133rem;
          line-height: 0.2933rem;
        }
        .leader-tag {
          top: 0.7467rem;
          width: 0.72rem;
          height: 0.3733rem;
          font-size: 0.24rem;
        }
        .refund-tag {
          width: 1.0667rem;
          height: 1.0667rem;
          line-height: 1.0667rem;
          font-size: 0.2133rem;
        }
      }
      .join-box {
        width: 1.0667rem;
        height: 1.0667rem;
        margin-left: 0.2933rem;
      }
    }
  }
}
</style>
